module.exports = __webpack_public_path__ + "img/79_40.cb00b25e.png";